import { haptic } from '../tg.js';

// Respawn bottom-sheet — 3 variants:
//   - respawn-available: chết với unlocks → "RESPAWN -X⭐" + Quit
//   - insufficient-star: chết, không đủ star → "BUY X⭐ & RESPAWN" + Quit
//   - cannot-respawn:    chết ở level 0 → "BACK TO MENU"
//
// Visual: slide-up sheet với full-width, glass surface, hero title, progress dots
// (show stake: "what user worked for"), cost panel, single primary CTA.
//
// Callbacks: onRespawn, onBuyStars, onQuit.
// Extra opts: `unlocked`, `total` — drives progress dots (optional, defaults 0/5).
export function showRespawnModal(parent, opts) {
  const {
    variant,
    cost = 0,
    balance = 0,
    required = 0,
    unlocked = 0,
    total = 5,
    onRespawn,
    onBuyStars,
    onQuit
  } = opts;

  const el = document.createElement('div');
  el.className = 'modal-overlay respawn-overlay';

  const dotsHTML = Array.from({ length: total }, (_, i) =>
    `<span class="rs-dot ${i < unlocked ? 'on' : ''}"></span>`
  ).join('');

  let body;
  if (variant === 'respawn-available') {
    const after = Math.max(0, balance - cost);
    body = `
      <div class="rs-hero">
        <div class="rs-skull">💀</div>
        <div class="rs-title rs-title-pink">YOU DIED</div>
        <div class="rs-sub">Continue the night and keep your unlocks?</div>
      </div>
      <div class="rs-progress">
        <div class="rs-progress-label">PROGRESS · ${unlocked}/${total} STAGES</div>
        <div class="rs-dots">${dotsHTML}</div>
      </div>
      <div class="rs-cost">
        <div class="rs-cost-row">
          <span class="rs-cost-label">Balance</span>
          <span class="rs-cost-val">⭐ ${balance}</span>
        </div>
        <div class="rs-cost-row danger">
          <span class="rs-cost-label">Respawn cost</span>
          <span class="rs-cost-val">−${cost}</span>
        </div>
        <div class="rs-cost-row total">
          <span class="rs-cost-label">After</span>
          <span class="rs-cost-val neon-gold">⭐ ${after}</span>
        </div>
      </div>
      <button class="btn-primary rs-cta" id="rs-respawn">
        <span class="rs-cta-label">RESPAWN</span>
        <span class="rs-cta-cost">−${cost}⭐</span>
      </button>
      <button class="rs-quit-link" id="rs-quit">Quit & give up</button>`;
  } else if (variant === 'insufficient-star') {
    const short = Math.max(0, required - balance);
    body = `
      <div class="rs-hero">
        <div class="rs-skull">⛔</div>
        <div class="rs-title rs-title-warn">NOT ENOUGH STARS</div>
        <div class="rs-sub">You need ${required}⭐ to respawn this stage</div>
      </div>
      <div class="rs-progress">
        <div class="rs-progress-label">PROGRESS · ${unlocked}/${total} STAGES</div>
        <div class="rs-dots">${dotsHTML}</div>
      </div>
      <div class="rs-cost">
        <div class="rs-cost-row">
          <span class="rs-cost-label">Required</span>
          <span class="rs-cost-val neon-gold">⭐ ${required}</span>
        </div>
        <div class="rs-cost-row">
          <span class="rs-cost-label">Balance</span>
          <span class="rs-cost-val">⭐ ${balance}</span>
        </div>
        <div class="rs-cost-row total danger">
          <span class="rs-cost-label">You need</span>
          <span class="rs-cost-val">+${short}⭐</span>
        </div>
      </div>
      <button class="btn-primary rs-cta" id="rs-buy">
        <span class="rs-cta-label">BUY ${short}⭐ &amp; RESPAWN</span>
      </button>
      <button class="rs-quit-link" id="rs-quit">Quit & give up</button>`;
  } else {
    // cannot-respawn (level 0)
    body = `
      <div class="rs-hero">
        <div class="rs-skull rs-skull-mute">💀</div>
        <div class="rs-title">GAME OVER</div>
        <div class="rs-sub">Catch beer to unlock a stage before you die — that's your revive ticket next time.</div>
      </div>
      <button class="btn-primary rs-cta" id="rs-quit-cta">
        <span class="rs-cta-label">BACK TO MENU</span>
      </button>`;
  }

  el.innerHTML = `
    <div class="respawn-sheet ${variant}">
      <div class="sheet-handle"></div>
      ${body}
    </div>`;
  parent.appendChild(el);

  // Slide-in haptic — heavy for death events feels right
  haptic('heavy');

  const sheet = el.querySelector('.respawn-sheet');
  requestAnimationFrame(() => sheet.classList.add('show'));

  const close = () => {
    if (sheet.classList.contains('closing')) return;
    sheet.classList.add('closing');
    setTimeout(() => el.remove(), 220);
  };

  const wire = (id, fn) => {
    const btn = el.querySelector(id);
    if (btn) btn.onclick = () => { haptic('medium'); close(); fn?.(); };
  };

  wire('#rs-respawn',  onRespawn);
  wire('#rs-buy',      onBuyStars);
  wire('#rs-quit',     onQuit);
  wire('#rs-quit-cta', onQuit);

  return { close };
}
